import React from 'react';
import { useTranslation } from 'react-i18next';
import { TitleHeader } from 'web-library';
import UploadSupportingDocumentsContent from '../../../modules/profile/components/UploadSupportingDocumentsContent';

const UploadSupportingDocuments = () => {
  const { t } = useTranslation();
  return (
    <>
      <TitleHeader title={t('profile->>CreateCandidateForm.UploadSupportingDocuments')} />
      <UploadSupportingDocumentsContent />
    </>
  );
};

export default UploadSupportingDocuments;
